import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/pages/HomePage/Home';
import Footer from './components/pages/Footer/Footer';
import Services from './components/pages/Services/Services';
import Contact from './components/pages/Contact/Contact';
import SignUp from './components/pages/SignUp/SignUp';
import Products from './components/pages/Products/Products';
import Terms from './components/pages/Terms/Terms';
import Terms2 from './components/pages/Terms/Terms2';
import RefundPolicy from './components/pages/Terms/RefundPolicy';
import CookieConsent from './components/CookieConsent/CookieConsent';

function App() {
  return (
    <Router>
      <Navbar/>
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/services' component={Services}/>
        <Route path='/log-in' component={SignUp}/>
        <Route path='/products' component={Products}/>
        <Route path='/contact' component={Contact}/>
        <Route path='/terms' component={Terms}/>
        <Route path='/privacy' component={Terms2}/>
        <Route path='/refundpolicy' component={RefundPolicy}/>
      </Switch>
      <Footer/>
      <CookieConsent/>
    </Router>
  );
}

export default App;
